import dayjs from 'dayjs';

const COOLDOWN_SHORT_DAYS = 7;
const COOLDOWN_LONG_DAYS = 30;
const SHOWS_BEFORE_LONG_COOLDOWN = 3;
export const MIN_POST_SAVES_TO_TRIGGER = 2;
export const MIN_RECENT_SESSIONS_SHOW_FORM = 2;

const POST_SAVE_COUNT_KEY = 'g2_post_save_count';

export const G2ReviewTracker = {
  incrementPostSaveCount(): number {
    const current = parseInt(
      sessionStorage.getItem(POST_SAVE_COUNT_KEY) ?? '0',
      10,
    );
    const next = current + 1;
    sessionStorage.setItem(POST_SAVE_COUNT_KEY, String(next));
    return next;
  },

  resetPostSaveCount(): void {
    sessionStorage.removeItem(POST_SAVE_COUNT_KEY);
  },

  canShow(formDisplayedAt: string | null, formDisplayCount: number): boolean {
    if (!formDisplayedAt) return true;
    const cooldownDays =
      formDisplayCount % (SHOWS_BEFORE_LONG_COOLDOWN + 1) === 0
        ? COOLDOWN_LONG_DAYS
        : COOLDOWN_SHORT_DAYS;
    return dayjs().isAfter(dayjs(formDisplayedAt).add(cooldownDays, 'day'));
  },
};
